import { DateTimeField, FormattedDateTime, Id } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createDatetimeDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "DATETIME_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createDatetimeDataFieldContactAttributeProfileHandler(
	id: Id,
	value: string | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<string, string | null> {
	const baseHandler = createDatetimeDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ? <FormattedDateTime dateTime={this.value} /> : "";
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<DateTimeField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value ?? "" };
		},
	};
}

export function createDatetimeDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createDatetimeDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "max-content",
	};
}
